import React, { useEffect, useRef, useState } from 'react';
import { clinicalTimeLabel } from '../utils/clinicalTime';

// A manual clock time needs a choice only during the repeated hour. Live “Now”
// values already carry their occurrence and never open this dialog.
export default function ClinicalTimeResolutionDialog() {
  const [requests, setRequests] = useState([]);
  const dialog = useRef(null);
  const pending = useRef([]);
  useEffect(() => {
    const receive = event => {
      event.detail.handled = true;
      pending.current.push(event.detail);
      setRequests([...pending.current]);
    };
    window.addEventListener('vela:resolve-clinical-time', receive);
    return () => {
      window.removeEventListener('vela:resolve-clinical-time', receive);
      pending.current.splice(0).forEach(request => request.resolve(null));
    };
  }, []);
  const current = requests[0];
  useEffect(() => {
    if (current && !dialog.current?.open) dialog.current?.showModal();
    if (!current) dialog.current?.close();
  }, [current]);
  const finish = value => {
    pending.current.shift()?.resolve(value);
    setRequests([...pending.current]);
  };
  return <dialog ref={dialog} aria-labelledby="clinical-clock-title" className="rounded-lg p-6 shadow-xl max-w-lg backdrop:bg-black/40"
    onCancel={event => { event.preventDefault(); finish(null); }}>
    {current && <>
      <h2 id="clinical-clock-title" className="text-lg font-semibold">Confirm the clock-change time</h2>
      <p className="my-3">{current.label}: {current.wall.replace('T', ' ')} occurred twice in {current.timeZone}. Which occurrence was charted?</p>
      <div className="flex flex-col gap-2">
        {current.candidates.map((value, index) => <button type="button" key={value} className="border rounded p-3 text-left hover:bg-gray-100" onClick={() => finish(value)}>
          {index === 0 ? 'Before' : 'After'} the clock change — {clinicalTimeLabel(value, current.timeZone)}
        </button>)}
        <button type="button" className="mt-2 underline" onClick={() => finish(null)}>Keep editing</button>
      </div>
    </>}
  </dialog>;
}
